import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=ce02afdc&scoped=true&lang=pug&"
import script from "./settings.vue?vue&type=script&lang=coffee&"
export * from "./settings.vue?vue&type=script&lang=coffee&"
import style0 from "./settings.vue?vue&type=style&index=0&id=ce02afdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce02afdc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/opt/buildhome/repo/components/loading.vue').default,Notifications: require('/opt/buildhome/repo/components/notifications/notifications.vue').default,SettingsNav: require('/opt/buildhome/repo/components/nav/settings-nav.vue').default})
